<template>
    <li v-for="(post, index) in orderedPosts" :key="`blog-post-${index}`">
        <a :href="post.Url" class="dropdown-item">
            <h2 class="dropdown-item__number">{{index + 1 }}</h2>
            <div class="dropdown-item__content">
                <p>{{post.Title}}</p>
                <p class="small dropdown-item-content__details">{{post.PublicationDate}}</p>
            </div>
        </a>

    </li>
</template>

<script>
    import { ref } from 'vue';

    export default {
        name: 'RecentPosts',
        props: {
            posts: {
                type: Array
            },
            amountOfPosts: {
                type: Number,
                default: 5
            }
        },
        setup(props) {
            const related = ref(props.content)
            const orderedPosts = ref(props.posts)

            orderedPosts.value = orderedPosts.value.sort((a, b) => {
                return Date.parse(b.PublicationDate) - Date.parse(a.PublicationDate)
            }).slice(0, props.amountOfPosts)

            return { related, orderedPosts };
        },
    };
</script>

<style lang="scss"></style>